export const RECENT_RANDOM_RECOMMENDATION_LIMIT = 4;
const STORAGE_KEY = "venaqqi_recent_random_place_ids";

const normalizeId = value => String(value ?? "").trim();

export const normalizeRecentRandomPlaceIds = values => {
  const seen = new Set();
  return (Array.isArray(values) ? values : [])
    .map(normalizeId)
    .filter(id => {
      if (!id || seen.has(id)) return false;
      seen.add(id);
      return true;
    })
    .slice(0, RECENT_RANDOM_RECOMMENDATION_LIMIT);
};

export const nextRecentRandomPlaceIds = (current, placeId) => normalizeRecentRandomPlaceIds([
  normalizeId(placeId),
  ...normalizeRecentRandomPlaceIds(current),
]);

export const excludeRecentRandomPlaces = (places, recentIds) => {
  const source = Array.isArray(places) ? places : [];
  if (source.length <= 1) return source;

  const recent = normalizeRecentRandomPlaceIds(recentIds);
  let blockedCount = recent.length;
  while (blockedCount > 0) {
    const blocked = new Set(recent.slice(0, blockedCount));
    const candidates = source.filter(place => !blocked.has(normalizeId(place?.id)));
    if (candidates.length) return candidates;
    blockedCount -= 1;
  }
  return source;
};

export const readRecentRandomPlaceIds = (storage = typeof window !== "undefined" ? window.sessionStorage : null) => {
  if (!storage) return [];
  try {
    return normalizeRecentRandomPlaceIds(JSON.parse(storage.getItem(STORAGE_KEY) || "[]"));
  } catch {
    return [];
  }
};

export const rememberRandomPlaceId = (placeId, storage = typeof window !== "undefined" ? window.sessionStorage : null) => {
  if (!storage) return [];
  const next = nextRecentRandomPlaceIds(readRecentRandomPlaceIds(storage), placeId);
  try { storage.setItem(STORAGE_KEY, JSON.stringify(next)); } catch { /* storage unavailable */ }
  return next;
};
